module.exports = __webpack_public_path__ + "static/media/usa_flag.389ad728.svg";